import React, { useContext, useRef, useState } from 'react';
import { FileUpload } from 'primereact/fileupload';
import axios from 'axios';
import { getStompClient } from 'app/config/websocket-middleware';
import { ToastContext } from 'app/context/ToastContext';

const PaymentImport = () => {
  const { showError } = useContext(ToastContext);
  const [logs, setLogs] = useState([]);
  const [uploadDisabled, setUploadDisabled] = useState(false);
  const fileUploadRef = useRef(null);

  const handleSocketConnection = jobId => {
    const stompClient = getStompClient();

    stompClient.connect({}, () => {
      stompClient.subscribe(`/topic/payment-upload/${jobId}`, message => {
        if (message.body !== 'end') {
          setLogs(prevLogs => [...prevLogs, message.body]);
        } else {
          setUploadDisabled(false);
          if (fileUploadRef.current) {
            fileUploadRef.current.clear();
          }
          stompClient.disconnect();
        }
      });
    });
  };

  const handleFileUpload = async event => {
    const files = event.files;

    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]);
    }

    setUploadDisabled(true);

    try {
      const response = await axios.post('api/payment/import', formData);

      if (response.status !== 200) {
        throw new Error('Failed to upload CSV file');
      }

      handleSocketConnection(response.data);
    } catch (error) {
      console.error('Error uploading CSV:', error);
      showError('Chyba', 'Nepodarilo sa nahrať importný súbor platieb.');
      setUploadDisabled(false);
    }
  };

  return (
    <>
      <div>
        <FileUpload
          ref={fileUploadRef}
          mode="advanced"
          multiple={true}
          name="files"
          accept=".csv,.xml"
          customUpload
          disabled={uploadDisabled}
          uploadHandler={event => {
            void handleFileUpload(event);
          }}
          chooseLabel="Načítať exportné súbory z bánk"
          uploadLabel="Nahrať"
          cancelLabel="Zrušiť"
        />
      </div>
      <div>
        <table>
          <thead>
            <tr>
              <th>Log</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((log, index) => (
              <tr key={index}>
                <td>{log}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PaymentImport;
